import {
  IonBadge,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonIcon,
  IonNote,
  IonRouterLink,
  IonRow,
  IonText,
  useIonRouter,
} from "@ionic/react";
// import { bookmarkOutline, shareOutline } from "ionicons/icons";
import {
  arrowForward,
  home,
  homeOutline,
  phonePortraitOutline,
} from "ionicons/icons";
import "./Post.css";
import { truncate } from "../utils/truncate";
import SocialLinks from "./SocialLinks";
const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
};
export const Post = ({ post }) => {
  const CONTENT_PREVIEW_LENGTH = 240;
  const SOCIAL_POST_ID = "info";
  const BUILDING_LOONLOG = createSlug(
    "Building LoonLog: Canada’s Own Social Media Platform"
  );
  const YOUR_STORY = createSlug(
    "Your Story, Our Story: The Heart of Community on LoonLog"
  );
  const WHY_LOONLOG = createSlug("Why LoonLog Is More Than Social Media");

  const router = useIonRouter();
  if (!post.inLanding) return null;
  if (post.id === "about") return null;
  return (
    <IonCard
      className="shadow info-post-card info-card"
      style={{ marginBottom: "15px" }}
    >
      <img src={post.image} alt="main post" className="blog-image" />

      <IonCardHeader>
        <IonRow className="ion-align-items-center ion-justify-content-between">
          <IonRow className="ion-align-items-center ion-justify-content-between ion-padding">
            <img
              src={post.authorImage}
              className="blog-author-avatar"
              alt="post author"
            />
            {post.id === WHY_LOONLOG && (
              <IonCardSubtitle
                className="ion-no-margin ion-no-padding ion-margin-start"
                style={{ margin: "10px", padding: "10px" }}
              >
                {post.author}
              </IonCardSubtitle>
            )}
            {post.id === BUILDING_LOONLOG && (
              <IonCardSubtitle
                className="ion-no-margin ion-no-padding ion-margin-start"
                style={{ margin: "10px", padding: "10px" }}
              >
                {post.author}
              </IonCardSubtitle>
            )}
            {post.id === YOUR_STORY && (
              <IonCardSubtitle
                className="ion-no-margin ion-no-padding ion-margin-start"
                style={{ margin: "10px", padding: "10px" }}
              >
                {post.author}
              </IonCardSubtitle>
            )}
            {post.id !== WHY_LOONLOG &&
              post.id !== BUILDING_LOONLOG &&
              post.id !== YOUR_STORY && (
                <IonCardTitle
                  className="blog-title"
                  style={{
                    marginTop: "0.75rem",
                    marginBottom: "0.75rem",
                    marginLeft: "10px",
                    paddingLeft: "10px",
                  }}
                >
                  {post.title}
                </IonCardTitle>
              )}
          </IonRow>
          <IonNote>{post.date}</IonNote>
        </IonRow>

        {post.id === YOUR_STORY && (
          <IonCardTitle
            className="blog-title"
            style={{
              marginTop: "0.75rem",
              marginBottom: "0.75rem",
              marginLeft: "10px",
              paddingLeft: "10px",
            }}
          >
            {post.title}
          </IonCardTitle>
        )}
        {post.id === BUILDING_LOONLOG && (
          <IonCardTitle
            className="blog-title"
            style={{
              marginTop: "0.75rem",
              marginBottom: "0.75rem",
              marginLeft: "10px",
              paddingLeft: "10px",
            }}
          >
            {post.title}
          </IonCardTitle>
        )}
        {post.id === WHY_LOONLOG && (
          <IonCardTitle
            className="blog-title"
            style={{
              marginTop: "0.75rem",
              marginBottom: "0.75rem",
              marginLeft: "10px",
              paddingLeft: "10px",
            }}
          >
            {post.title}
          </IonCardTitle>
        )}
      </IonCardHeader>

      <IonCardContent
        className="post-card-content"
        style={{
          marginLeft: "10px",
          marginRight: "10px",
          paddingLeft: "10px",
          paddingRight: "10px",
          // paddingBottom: "10px",
          // marginBottom: "10px",
        }}
      >
        {post.id === SOCIAL_POST_ID ? (
          <SocialLinks />
        ) : (
          <div className="blog-content">
            {/* 1. Render the HTML content */}
            <span
              dangerouslySetInnerHTML={{
                __html: truncate(post.content, CONTENT_PREVIEW_LENGTH),
              }}
            />
            {/* 2. Render the link as a sibling (immediately after) */}
            <IonRouterLink
              className="read-more-inline"
              routerLink={`/blog/${post.id}`}
              style={{ marginLeft: "5px" }} // Add a little spacing
            >
              Read more...
            </IonRouterLink>
          </div>
        )}

        <IonRow className="blog-footer ion-align-self-center ion-justify-content-between">
          <div>
            <span onClick={() => router.push("/")}>
              <IonButton fill="clear" color="primary">
                {/* 📲 */}
                <IonIcon
                  icon={phonePortraitOutline}
                  style={{ fontSize: "16px", opacity: 0.7 }}
                />
              </IonButton>
            </span>
            <IonButton fill="clear" color="primary">
              🇨🇦
            </IonButton>
          </div>

          <IonBadge color="primary" className="blog-category">
            {truncate(post.category, 18)}
          </IonBadge>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};
